/**
 * Runtime configuration helper.
 *
 * In production (Docker/EKS), values come from window.__RUNTIME_CONFIG__,
 * which is populated by docker-entrypoint.sh from container environment variables.
 *
 * In local development, falls back to process.env (CRA injects REACT_APP_* at build time).
 */
export function getConfig(key) {
  const runtimeValue = window.__RUNTIME_CONFIG__?.[key];
  if (runtimeValue !== undefined && runtimeValue !== '') {
    return runtimeValue;
  }
  return process.env[key];
}
